// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.lplogofont {
    font-family: 'Century Gothic';
    color: #FFFFFF
}

.lploginfont {
    font-family: 'Century Gothic';
    color: #eee
}

.projectCardActive_ {
    background-color: #7daffa;
}

.projectCardActive {
    background-color: #dae5f6;
}

.projectCardInActive_ {
    background-color: #EBEBE4;
}

.projectCardInActive {
    background-color: #f3f3ed;
}

.btn-link:focus {
    outline: none;
    box-shadow: none;
}

.modal-90w {
    width: 90%;
    max-width: none !important;
}

.tableTextArea {
    border: none;
    width: 100%;
    height: 100%;
    /* <=iOS4, <= Android  2.3 */
    /* FF1+ */
    box-sizing: border-box;
    /* Chrome, IE8, Opera, Safari 5.1*/
    padding: 0; 
    white-space: pre-wrap;
}

.mytooltip {
    position: relative;
    background: rgba(132, 237, 226, 0.7);
    color: rgb(27, 24, 24);
    visibility: hidden;
    padding: 5px;
    border-radius: 5px;
  }
  .mytooltip-arrow {
    position: absolute;
    top: 100%;
    left: 50%;
    border-width: 5px;
    border-style: solid;
    border-color: rgba(0, 0, 0, 0.7) transparent transparent;
  }
  .instruction {
    font-size: 12px;
    color: var(--instruction-color);
  }
  .instruction {
    line-height: 1.3em;
    margin: .5em 0;
  }
  legend + * {
    clear: left;
  }`, "",{"version":3,"sources":["webpack://./src/components/css/custom.min.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,6BAA6B;IAC7B;AACJ;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,gBAAgB;AACpB;;AAEA;IACI,UAAU;IACV,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,YAAY;IAEZ,4BAA4B;IAE5B,SAAS;IACT,sBAAsB;IACtB,kCAAkC;IAClC,UAAU;IACV,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,oCAAoC;IACpC,sBAAsB;IACtB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;EACpB;EACA;IACE,kBAAkB;IAClB,SAAS;IACT,SAAS;IACT,iBAAiB;IACjB,mBAAmB;IACnB,wDAAwD;EAC1D;EACA;IACE,eAAe;IACf,+BAA+B;EACjC;EACA;IACE,kBAAkB;IAClB,cAAc;EAChB;EACA;IACE,WAAW;EACb","sourcesContent":[".lplogofont {\n    font-family: 'Century Gothic';\n    color: #FFFFFF\n}\n\n.lploginfont {\n    font-family: 'Century Gothic';\n    color: #eee\n}\n\n.projectCardActive_ {\n    background-color: #7daffa;\n}\n\n.projectCardActive {\n    background-color: #dae5f6;\n}\n\n.projectCardInActive_ {\n    background-color: #EBEBE4;\n}\n\n.projectCardInActive {\n    background-color: #f3f3ed;\n}\n\n.btn-link:focus {\n    outline: none;\n    box-shadow: none;\n}\n\n.modal-90w {\n    width: 90%;\n    max-width: none !important;\n}\n\n.tableTextArea {\n    border: none;\n    width: 100%;\n    height: 100%;\n    -webkit-box-sizing: border-box;\n    /* <=iOS4, <= Android  2.3 */\n    -moz-box-sizing: border-box;\n    /* FF1+ */\n    box-sizing: border-box;\n    /* Chrome, IE8, Opera, Safari 5.1*/\n    padding: 0; \n    white-space: pre-wrap;\n}\n\n.mytooltip {\n    position: relative;\n    background: rgba(132, 237, 226, 0.7);\n    color: rgb(27, 24, 24);\n    visibility: hidden;\n    padding: 5px;\n    border-radius: 5px;\n  }\n  .mytooltip-arrow {\n    position: absolute;\n    top: 100%;\n    left: 50%;\n    border-width: 5px;\n    border-style: solid;\n    border-color: rgba(0, 0, 0, 0.7) transparent transparent;\n  }\n  .instruction {\n    font-size: 12px;\n    color: var(--instruction-color);\n  }\n  .instruction {\n    line-height: 1.3em;\n    margin: .5em 0;\n  }\n  legend + * {\n    clear: left;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
